import {Pipe, PipeTransform} from '@angular/core';
import {UtilService} from '../util/util.service';
import {ChangeVO} from '../generate/ChangeVO';

@Pipe({
  name: 'displayValueFromChange'
})
export class DisplayValueFromChangePipe implements PipeTransform {

  constructor(public utilService: UtilService) {
  }

  transform(value: any, field: string, change: ChangeVO, section: string): any {
    switch (section) {
      case 'contact':
        return this.contactChange(value, field, change);
      case 'metadata':
        return this.metadataChange(value, field, change);
      case 'metadataBoolean':
        return this.metadataBooleanChange(value, field, change);
    }
  }

  private contactChange(value: any, field: any, change: ChangeVO) {
    const fieldChange: ChangeVO = this.utilService.getContactFieldChange(field, change);

    let returnVal = this.getStringValue(fieldChange, value);

    if (field === 'fax' && returnVal) {
      return returnVal + ' (fax)';
    } else {
      return returnVal;
    }
  }

  metadataChange(value: any, field: string, change: ChangeVO): string {
    const fieldChange: ChangeVO = this.utilService.getChange(field, change);
    return this.getStringValue(fieldChange, value);

  }

  getStringValue(fieldChange: ChangeVO, value: any) {
    let displayValue: string;
    if (fieldChange != null) {
      displayValue = fieldChange.operationType === 'REMOVE' ? fieldChange.oldVal.toString() : this.utilService.getDisplayValue(value);
    } else {
      displayValue = this.utilService.getDisplayValue(value);
    }
    return displayValue;
  }


  metadataBooleanChange(value: any, field: string, change: ChangeVO): boolean {
    const fieldChange: ChangeVO = this.utilService.getChange(field, change);

    let displayValue: boolean;
    if (fieldChange != null) {
      displayValue = fieldChange.operationType === 'REMOVE' ? !!fieldChange.oldVal : value;
    } else {
      displayValue = value;
    }

    if (!displayValue) {
      displayValue = false;
    }

    return displayValue;
  }


}
